import { AccountFacade } from '@mode/accounts/contract';
import type { StateParams } from '@uirouter/core';
import * as fromServices from '~/modules/report-viewer/services';

export const explorationRoutes = [
  {
    name: 'explorationShow',
    url: '/:account/reports/:reportId/explorations',
    template: `<exploration-container></exploration-container>`,
    onEnter: [
      '$stateParams',
      fromServices.REPORT_VIEW_DATA_SERVICE_ID,
      'AccountFacade',
      (
        $params: StateParams,
        reportViewDataService: fromServices.ReportViewDataService,
        accountFacade: AccountFacade
      ) => {
        accountFacade.loadReportOwner($params.account);
        reportViewDataService.initContainer();
      },
    ],
    abstract: true,
  },
  {
    name: 'explorationShow.edit',
    url: '/:explorationId/edit',
    template: `<exploration-designer></exploration-designer>`,
    onEnter: [
      '$stateParams',
      fromServices.EXPLORATION_VIEW_DATA_SERVICE_ID,
      ($stateParams, explorationViewDataService: fromServices.ExplorationViewDataService) => {
        explorationViewDataService.selectExploration($stateParams.account, $stateParams.explorationId, true);
      },
    ],
  },
  {
    name: 'explorationShow.focus',
    url: '/:explorationId/focus',
    template: `<exploration-viewer></exploration-viewer>`,
    onEnter: [
      '$stateParams',
      fromServices.EXPLORATION_VIEW_DATA_SERVICE_ID,
      ($stateParams, explorationViewDataService: fromServices.ExplorationViewDataService) => {
        explorationViewDataService.selectExploration($stateParams.account, $stateParams.explorationId, false);
      },
    ],
  },
  {
    name: 'explorationShow.explore',
    url: '/:explorationId/explore',
    template: `<exploration-explorer></exploration-explorer>`,
    data: {
      hasChanges: false,
    },
    params: {
      skipLoad: false,
    },
    onEnter: [
      '$stateParams',
      fromServices.EXPLORATION_VIEW_DATA_SERVICE_ID,
      ($stateParams, explorationViewDataService: fromServices.ExplorationViewDataService) => {
        // We want to allow the ui-sref action to decide if we should skip loading the exploration. This allows
        // us to keep any transforms the user may have applied in the focus state, like hierarchy change.
        if ($stateParams.skipLoad === true) {
          explorationViewDataService.clearExplorationResource();
        } else {
          explorationViewDataService.selectExploration($stateParams.account, $stateParams.explorationId, false);
        }
      },
    ],
  },
];
